import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";
import type { Storage } from "../utils/backend-types";
import { COMPONENT_QUERY_KEY } from "../utils/constants";
import { ObjectName } from "../utils/enums";

export const storageQueries = {
  detail: (storageId?: number) =>
    queryOptions<Storage>({
      queryKey: [COMPONENT_QUERY_KEY[ObjectName.Storage], { storageId }],
      queryFn: storageId ? () => fetchStorage(storageId) : skipToken
    })
};

export function useStorage(storageId?: number) {
  return useQuery(storageQueries.detail(storageId));
}

async function fetchStorage(storageId: number) {
  const response = await api.get<Storage>(urls.api.storage(storageId));
  return response.data;
}
